/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from "react";
import { Badge } from "../../components/ui";
import PropTypes from "prop-types";
import { withRouter } from "../../hooks/withRouter";
import Photo from "./notif-grid-table/photo";
import { Link } from "react-router-dom";
import { formatToLocalDate } from "../../utils";

const Author = ({ url, name, date, avatar, badgeImg, badgeImgClass, badges, nameStyle }) => {
  const alertStyles = window.location.pathname == "/alerts";
  const mobilepixel = window.screen.width < 600;
    return (
      <div className="wrapper author">
        {url && (
          <Link to={url} style={nameStyle}>
            <Photo style={{ marginTop: 20 }} avatar={avatar} name={name} />
          </Link>
        )}
        <div
          style={{ marginTop: alertStyles && !mobilepixel ? "-5px" : "" }}
          className="d-flex flex-column justify-content-center"
        >
          <span
            style={nameStyle ? nameStyle : undefined}
            className="card-post__author-name"
          >
            {url && (
              <Link to={url} style={nameStyle}>
                {name}
              </Link>
            )}
            {badgeImg && (
              <img
                src={badgeImg}
                alt="Publisher Verified"
                style={{
                  width: 15,
                  height: 15,
                  marginLeft: 4,
                  verticalAlign: "middle",
                  marginBottom: 2,
                }}
                className={badgeImgClass}
              />
            )}
          </span>
          <small className="text-muted">
            {date ? formatToLocalDate(date) : date}
          </small>
          {badges && (
            <small className="text-muted">
              {badges.map((badge, idx) => {
                return (
                  <Badge
                    key={idx}
                    pill
                    style={{
                      padding: alertStyles ? "0.175rem 0.5rem" : {},
                    }}
                    className={`card-post__category ${badge.badge}`}
                  >
                    {badge.title}
                  </Badge>
                );
              })}
            </small>
          )}
        </div>
      </div>
    );
};

Author.propTypes = {
  name: PropTypes.string,
  date: PropTypes.string,
  avatar: PropTypes.string,
  badgeImg: PropTypes.string,
  badgeImgClass: PropTypes.string,
  badges: PropTypes.array,
};

export default withRouter(Author);
